export default "__VITE_ASSET__cOcEQq1n__"